<div class="mb-3">
  <label
    *ngIf="hasLabel"
    class="form-label"
    [attr.for]="resolvedInputId"
    >{{ label | translate
    }}<span *ngIf="required"> * </span></label
  >
  <div [class.input-group]="prefix">
    <span *ngIf="prefix" class="input-group-text">{{
      prefix
    }}</span>
    <input
      [formControl]="field"
      class="form-control"
      [class.disabled]="disabled"
      [placeholder]="placeholder | translate"
      [required]="required && !disabled"
      [readonly]="disabled"
      [type]="type"
      [min]="min"
      [max]="max"
      [attr.id]="resolvedInputId"
      #autoFocusInput
    />
  </div>
  <div *ngIf="hasHint" class="form-text">
    {{ hint | translate }}
  </div>
  <div *ngIf="isPending" class="form-text">
    {{ 'label.pending' | translate }}
  </div>
  <div *ngIf="showError" class="form-text text-danger">
    {{
      error
        | translate
          : {
              maxlength:
                field.errors?.maxlength?.requiredLength
            }
    }}
  </div>
</div>
